import { Json } from 'fp-ts/Json';
import * as C from 'io-ts/Codec';
import { UserRole } from 'src/modules/common/types/UserRole';

export const USER_ROLE: C.Codec<unknown, Json, UserRole> = C.literal(
  UserRole.USER,
  UserRole.ADMIN,
);
